import React from 'react';
import { Link } from 'react-router-dom';

const ComingSoon = ({ title = 'This feature', icon = '🚧' }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <div className="text-6xl mb-4">{icon}</div>
      <h1 className="text-3xl font-bold text-gray-800 mb-2">{title}</h1>
      <p className="text-lg text-gray-500 mb-2">Coming Soon</p>
      <p className="text-gray-400 mb-8 max-w-md">
        This section is under development and will be available in a future release.
        Check back soon!
      </p>
      <Link
        to="/dashboard"
        className="bg-teal-500 hover:bg-teal-600 text-white font-bold py-2 px-6 rounded transition-colors"
      >
        ← Back to Dashboard
      </Link>
    </div>
  );
};

export default ComingSoon;
